import { Cookies } from 'react-cookie'

const CookiesUtil = new Cookies()
export default CookiesUtil
